export { default as PartDetailsTable } from "./PartDetailsTable.vue";
